import * as React from 'react';
import { Dialog, DialogContent, Box, Typography } from '@mui/material';
import ShsButton from './Fields/ShsButton';
import CircleWarning from 'src/assets/CircleWarning';
import { interFontStyle, deleteModalsStyles } from 'src/styles';

interface ShsDeactivateConfirmDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    children: React.ReactNode;
    confirmLabel: string;
    cancelLabel?: string;
}

const ShsDeactivateConfirmDialog: React.FC<ShsDeactivateConfirmDialogProps> = ({
    open,
    onClose,
    onConfirm,
    title,
    children,
    confirmLabel,
    cancelLabel = 'Скасувати'
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth sx={deleteModalsStyles}>
            <DialogContent>
                <div className="shs-modal-header">
                    <Box sx={{ textAlign: 'center' }}>
                        <CircleWarning />
                    </Box>
                    <Typography variant="h5" component="h5" mb={2} mt={1} fontWeight="600" align="center">
                        {title}
                    </Typography>
                </div>
                <div className="shs-modal-body">
                    <Typography component="div" mb={3} align="center" sx={interFontStyle}>
                        {children}
                    </Typography>
                </div>
                <div className="shs-modal-footer" style={{ display: 'flex', justifyContent: 'center' }}>
                    <ShsButton
                        label={cancelLabel}
                        styleType="outline"
                        onClick={onClose}
                        sx={{ minWidth: '220px', marginRight: '1em', whiteSpace: 'nowrap' }}
                    />
                    <ShsButton
                        label={confirmLabel}
                        styleType="filled-danger"
                        onClick={onConfirm}
                        sx={{ minWidth: '220px', whiteSpace: 'nowrap' }}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ShsDeactivateConfirmDialog;
